export interface VehicleSuspension {
    id: number;
    name: string;
}

export const VEHICLE_SUSPENSIONS: VehicleSuspension[] = [
    { id: 0, name: "Empty" },
    { id: 1, name: "Steel" },
    { id: 2, name: "SteelAndAir" },
    { id: 3, name: "Air" }
];